import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { useDispatch } from 'store/hooks';

export const useUpdateClientHomePage = (
    onSuccess: (client: Pick<ClientT, 'homePageUrl'>) => void,
) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    return useMutation({
        mutationFn: async (data: {
            bind: string;
            homePageUrl: string | null;
        }) => {
            const response = await RQAPICallWithData<
                Pick<ClientT, 'homePageUrl'>
            >({
                endpoint: `support/${data.bind}/home_page`,
                method: 'PUT',
                body: {
                    homePageUrl: data.homePageUrl,
                },
            });
            return response.content.data;
        },

        onError: () => {
            dispatch.vision.notifyUser({
                message: t(
                    'support.decisionConfiguration.decisionHomePage.homePageUpdateFailed',
                ),
                snackType: 'error',
            });
        },

        onSuccess: (client) => {
            onSuccess(client);
            dispatch.vision.notifyUser({
                message: t(
                    'support.decisionConfiguration.decisionHomePage.homePageUpdated',
                ),
                snackType: 'success',
            });
        },
    });
};
